import { useState } from "react";

import ChevronDown from "@uui/ChevronDown";

import IconHeading from "@app/analytics/components/IconHeading";
import { ICON_BY_CATEGORY } from "@app/analytics/components/Icons";
import useTopicReport from "@app/analytics/TopicReport/hooks/useTopicReport";
import {
  EmptySummaryText,
  ExpandableSummaryContainer,
  ExpandableSummaryText,
  SummaryText,
} from "@app/analytics/TopicReport/TopicReportNotes/styles";
import useMeasure from "@app/common/hooks/useMeasure";

import IconButton from "@rui/IconButton";
import { Column, Row } from "@rui/Stack";

const SummaryIcon = ICON_BY_CATEGORY.summary.Icon;

const TopicReportSummary = () => {
  const [expanded, setExpanded] = useState(false);
  const [previewTextRef, , { innerHeight: previewTextHeight }] = useMeasure();
  const [fullTextRef, , { innerHeight: fullTextHeight }] = useMeasure();

  const { topic } = useTopicReport();

  const handleToggleSummaryExpanded = () => setExpanded((e) => !e);

  const text = topic?.summary;
  const expandable = expanded || previewTextHeight < fullTextHeight;

  return (
    <Column spacing={1}>
      <Row variant="apart" minHeight="34px">
        <IconHeading
          color="shades.ghost.500"
          startIcon={<SummaryIcon sx={{ color: "shades.primary.500" }} />}
        >
          Summary
        </IconHeading>
        {expandable && (
          <IconButton
            variant="outlined"
            size="small"
            sx={{ borderRadius: "8px" }}
            onClick={handleToggleSummaryExpanded}
          >
            <ChevronDown
              sx={{
                fontSize: "18px",
                transform: expanded ? "rotate(180deg)" : undefined,
              }}
            />
          </IconButton>
        )}
      </Row>
      {text ? (
        <ExpandableSummaryContainer>
          <ExpandableSummaryText
            ref={previewTextRef}
            className={expanded ? "expanded" : "collapsed"}
          >
            {text}
          </ExpandableSummaryText>
          <SummaryText ref={fullTextRef} className="hidden" position="absolute">
            {text}
          </SummaryText>
        </ExpandableSummaryContainer>
      ) : (
        <EmptySummaryText>No summary generated</EmptySummaryText>
      )}
    </Column>
  );
};

export default TopicReportSummary;
